// extracted by mini-css-extract-plugin
export default {"page":"kL-z","cartModal":"lL-z","checkout":"mL-z","placeholder":"nL-z","account":"oL-z"};